import React, { useState } from "react";
import {
    Calculator,
    ChevronDown,
    FileDown,
    Loader2,
    Mail,
    Scale,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { DK_PDF_SABLONLARI } from "./constants";

const IKON = {
    calculator: Calculator,
    mail: Mail,
    scale: Scale,
};

const RENK = {
    emerald: "border-emerald-500/35 bg-emerald-500/10 hover:bg-emerald-500/20 text-emerald-100",
    sky: "border-sky-500/35 bg-sky-500/10 hover:bg-sky-500/20 text-sky-100",
    gold: "border-[#D4AF37]/40 bg-[#D4AF37]/10 hover:bg-[#D4AF37]/20 text-[#F3E5AB]",
};

export default function DkPdfSablonMenu({
    disabled,
    loading,
    onIndir,
    compact = false,
    className = "",
    hint,
}) {
    const [open, setOpen] = useState(false);
    const bloklu = disabled || !onIndir;

    if (compact) {
        return (
            <div className={`relative ${className}`}>
                <Button
                    size="sm"
                    variant="outline"
                    disabled={bloklu || loading}
                    title={bloklu ? hint || "Önce hesap yapın" : "PDF şablonları"}
                    onClick={() => {
                        if (bloklu) return;
                        setOpen((v) => !v);
                    }}
                    className="border-[#D4AF37]/35"
                >
                    {loading ? (
                        <Loader2 className="h-4 w-4 animate-spin mr-1" />
                    ) : (
                        <FileDown className="h-4 w-4 mr-1 text-[#D4AF37]" />
                    )}
                    PDF
                    <ChevronDown className="h-3 w-3 ml-1 opacity-60" />
                </Button>
                {open && (
                    <>
                        <button
                            type="button"
                            className="fixed inset-0 z-40"
                            aria-label="Kapat"
                            onClick={() => setOpen(false)}
                        />
                        <div className="absolute bottom-full right-0 mb-2 z-50 w-72 rounded-xl border border-white/15 bg-[#0c1222] shadow-2xl p-2 space-y-1">
                            {DK_PDF_SABLONLARI.map((s) => {
                                const Icon = IKON[s.icon] || FileDown;
                                return (
                                    <button
                                        key={s.id}
                                        type="button"
                                        disabled={loading}
                                        onClick={() => {
                                            setOpen(false);
                                            onIndir(s.id);
                                        }}
                                        className={`w-full text-left rounded-lg border px-3 py-2.5 transition ${RENK[s.renk] || RENK.emerald}`}
                                    >
                                        <div className="flex items-start gap-2">
                                            <Icon className="h-4 w-4 shrink-0 mt-0.5 opacity-80" />
                                            <div>
                                                <div className="text-xs font-semibold">{s.etiket}</div>
                                                <div className="text-[10px] opacity-75 mt-0.5 leading-snug">
                                                    {s.aciklama}
                                                </div>
                                            </div>
                                        </div>
                                    </button>
                                );
                            })}
                        </div>
                    </>
                )}
            </div>
        );
    }

    return (
        <div className={`rounded-xl border border-[#D4AF37]/20 bg-[#0c1222]/90 p-4 space-y-3 ${className}`}>
            <div>
                <h3 className="text-sm font-semibold text-white flex items-center gap-2">
                    <FileDown className="h-4 w-4 text-[#D4AF37]" />
                    Kurumsal PDF Şablonları
                </h3>
                <p className="text-[11px] text-slate-500 mt-1">
                    {hint ||
                        "Hesap tamamlandıktan sonra aşağıdaki şablonlardan birini indirin — tamamı MBS kurumsal kimlik ile üretilir."}
                </p>
            </div>
            <div className="grid sm:grid-cols-3 gap-2">
                {DK_PDF_SABLONLARI.map((s) => {
                    const Icon = IKON[s.icon] || FileDown;
                    return (
                        <button
                            key={s.id}
                            type="button"
                            disabled={bloklu || loading}
                            onClick={() => onIndir?.(s.id)}
                            className={`rounded-xl border p-3 text-left transition disabled:opacity-40 disabled:cursor-not-allowed ${RENK[s.renk] || RENK.emerald}`}
                        >
                            <div className="flex items-center gap-2 mb-2">
                                {loading ? (
                                    <Loader2 className="h-4 w-4 animate-spin" />
                                ) : (
                                    <Icon className="h-4 w-4 opacity-90" />
                                )}
                                <span className="text-xs font-semibold">{s.etiket}</span>
                            </div>
                            <p className="text-[10px] opacity-80 leading-snug">{s.aciklama}</p>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
